import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 }
};

export const FAQSection = ({ t }) => (
  <section id="faq" className="py-12 md:py-24 px-4 md:px-8 bg-white">
    <div className="max-w-3xl mx-auto">
      <motion.div {...fadeUp} className="text-center mb-8 md:mb-12">
        <h2 className="font-gluten text-2xl sm:text-3xl md:text-4xl text-agave mb-4">
          {t("faq_title")}
        </h2>
        <p className="font-nunito text-base sm:text-lg text-muted-foreground">
          {t("faq_subtitle")}
        </p>
      </motion.div>
      <motion.div {...fadeUp}>
        <Accordion type="single" collapsible className="space-y-3 md:space-y-4" data-testid="faq-accordion">
          {[
            { id: "safe", q: t("faq_1_q"), a: t("faq_1_a") },
            { id: "usage", q: t("faq_2_q"), a: t("faq_2_a") },
            { id: "works", q: t("faq_3_q"), a: t("faq_3_a") },
            { id: "shipping", q: t("faq_4_q"), a: t("faq_4_a") },
            { id: "benefits", q: t("faq_5_q"), a: t("faq_5_a") }
          ].map((faq) => (
            <AccordionItem 
              key={`faq-${faq.id}`} 
              value={`faq-${faq.id}`}
              className="bg-bone rounded-xl md:rounded-2xl px-4 md:px-6 border-none"
              data-testid={`faq-item-${faq.id}`}
            >
              <AccordionTrigger className="font-fredoka font-bold text-left text-sm sm:text-base text-foreground hover:no-underline py-4 md:py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="font-nunito text-sm sm:text-base text-muted-foreground pb-4 md:pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);
